export const INSTAGRAM_AUTH_CODE_STORAGE_KEY = 'instagramAuthCode';
